var _path, _mask, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCorporateCallWaiting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M3.946 9.755c-.34.34-.548.894-.516 1.735.031.842.302 1.892.825 3.093 1.043 2.398 3.022 5.247 5.708 7.96h.002l.029.03.008.008.007.007.005.005v.001L3.946 9.755zm0 0 .002-.003 1.234-1.246a.79.79 0 0 0 .094-.091A1.059 1.059 0 0 1 6.7 8.46l2.655 2.655a1.03 1.03 0 0 1 .005 1.469l-.005.005-1.948 1.947c-.455.456-.494 1.085-.414 1.603.083.536.316 1.13.637 1.735.646 1.219 1.734 2.642 3.099 4.006 1.365 1.365 2.788 2.45 4.007 3.094.605.32 1.198.552 1.733.636.516.08 1.143.045 1.6-.404l.004-.004 1.107-1.107.84-.84.005-.006c.4-.407 1.051-.407 1.45 0l.007.006 2.667 2.654M3.946 9.755 24.149 25.91m0 0 .001.001.53-.532-.531.53m-14.083-3.263-.528.532.53-.53v-.001l-.002-.001z",
    fill: "url(#wbhf5161ca)",
    stroke: "url(#egeizqcmwb)",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.35
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "tplr7ayhxd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m24.372 28.206-.987.987c-.507.507-1.227.734-2.108.734-2.88 0-7.51-2.561-11.739-6.75l-.053-.053-.053-.054c-5.47-5.522-8.164-11.699-6.017-13.847l.987-.987c-2.147 2.148.547 8.325 6.017 13.847.013.014.04.027.053.054l.053.053c4.23 4.189 8.858 6.75 11.74 6.75.88 0 1.6-.227 2.107-.734z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m24.372 28.206-.987.987c-.507.507-1.227.734-2.108.734-2.88 0-7.51-2.561-11.739-6.75l-.053-.053-.053-.054c-5.47-5.522-8.164-11.699-6.017-13.847l.987-.987c-2.147 2.148.547 8.325 6.017 13.847.013.014.04.027.053.054l.053.053c4.23 4.189 8.858 6.75 11.74 6.75.88 0 1.6-.227 2.107-.734z",
    fill: "#0055B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m23.385 29.193-1.06-1.06 1.06 1.06zM9.538 23.177l-1.06 1.06.005.006 1.055-1.066zm-.053-.053 1.06-1.06-1.06 1.06zm-.053-.054-1.066 1.056.005.005 1.06-1.06zM3.415 9.223l-1.06-1.06 1.06 1.06zm7.004 12.86L9.353 23.14l.005.005 1.06-1.06zm.053.054-1.342.67.11.218.171.172 1.061-1.06zm.053.053-1.06 1.06.005.006 1.055-1.066zm12.787 4.956-.987.987 2.12 2.121.988-.987-2.121-2.121zm-.987.987c-.134.133-.412.294-1.047.294v3c1.125 0 2.288-.293 3.168-1.173l-2.121-2.121zm-1.047.294c-1.06 0-2.668-.495-4.623-1.608-1.917-1.09-4.028-2.693-6.061-4.708l-2.111 2.132c2.195 2.174 4.513 3.946 6.688 5.184 2.137 1.215 4.285 2 6.107 2v-3zm-10.679-6.31-.053-.054-2.122 2.121.054.054 2.121-2.122zm-1.114 1.007 1.06-1.06v-.001l-.001-.002-.005-.004-.015-.016-.032-.031-2.121 2.121.032.032.015.015.005.005v.001h.001l1.061-1.06zm1.012-1.11C7.86 19.35 5.94 16.577 4.942 14.284c-.5-1.15-.736-2.106-.763-2.822-.027-.714.153-1.033.297-1.177L2.355 8.163c-.93.93-1.22 2.188-1.174 3.41.046 1.218.422 2.555 1.01 3.907 1.18 2.713 3.344 5.788 6.175 8.646l2.131-2.111zm-6.021-11.73.987-.987-2.121-2.121-.987.987 2.12 2.121zM3.342 7.176c-.93.93-1.22 2.188-1.174 3.41.046 1.218.422 2.554 1.01 3.906 1.181 2.714 3.344 5.788 6.175 8.647l2.132-2.111c-2.64-2.665-4.558-5.44-5.555-7.732-.501-1.151-.737-2.106-.764-2.822-.026-.714.154-1.033.297-1.177L3.342 7.176zm6.016 15.968c.044.044.083.077.106.097l.05.04c.026.02-.006-.005-.029-.024a1.4 1.4 0 0 1-.355-.45l2.684-1.341a1.597 1.597 0 0 0-.408-.513 1.359 1.359 0 0 1 .074.07l-2.122 2.12zm.053.053.054.054 2.121-2.122-.053-.053-2.122 2.121zm.059.059c2.195 2.174 4.513 3.946 6.689 5.183 2.136 1.216 4.284 2.001 6.106 2.001v-3c-1.06 0-2.668-.496-4.623-1.608-1.917-1.09-4.027-2.694-6.06-4.708L9.47 23.256zm12.795 7.184c1.125 0 2.288-.293 3.168-1.173l-2.121-2.121c-.134.133-.412.294-1.047.294v3z",
    fill: "url(#ci1n0l048c)",
    mask: "url(#tplr7ayhxd)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m25.777 26.793-2.402 2.401c-.506.507-1.227.734-2.107.734-2.882 0-7.51-2.561-11.74-6.75l-.053-.053-.053-.054c-5.47-5.523-8.164-11.7-6.017-13.847l2.388-2.401a1.804 1.804 0 0 1 2.535 0l2.655 2.655a1.78 1.78 0 0 1 0 2.534L9.035 13.96c-.827.827.667 3.628 3.322 6.283 2.654 2.655 5.456 4.135 6.283 3.322l1.947-1.948a1.764 1.764 0 0 1 2.522 0l2.668 2.655a1.788 1.788 0 0 1 0 2.52z",
    stroke: "url(#puojysw4be)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.206 11.576v2.826l1.798 1.028m2.827-1.028a4.626 4.626 0 1 1-9.252 0 4.626 4.626 0 0 1 9.252 0z",
    stroke: "url(#8oxt3nudxf)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "wbhf5161ca",
    x1: 19.389,
    y1: 41.991,
    x2: -3.567,
    y2: 32.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "egeizqcmwb",
    x1: 19.389,
    y1: 41.991,
    x2: -3.567,
    y2: 32.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ci1n0l048c",
    x1: 18.775,
    y1: 41.547,
    x2: -3.339,
    y2: 32.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "puojysw4be",
    x1: 20.201,
    y1: 42.584,
    x2: -3.885,
    y2: 33.149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "8oxt3nudxf",
    x1: 20.445,
    y1: 23.983,
    x2: 11.016,
    y2: 20.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporateCallWaiting);
export default __webpack_public_path__ + "static/media/corporateCallWaiting.21df5db97ccccddebd33af61ad1d7210.svg";
export { ForwardRef as ReactComponent };